<!-- =========================================================================================
    File Name: VerticalNavMenuItem.vue
    Description: Vertical NavMenu item component. Extends vuesax framework's 'vs-sidebar-item' component
    Component Name: VerticalNavMenuItem
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    v-if="canSee"
    class="vs-sidebar--item menu-item-custom "
    :class="[
      {'vs-sidebar-item-active': activeLink},
      {'menu-disabled' : isDisabled}
    ]"
  >
    <vx-tooltip :text="tooltipText" v-if="isDisabled">
      <a @click="clickLink()">
        <div class="area-icons">
          <feather-icon
            :icon="icone"
            :svgClasses="['h-8 w-8 icon-safra']"
            :class="{'menu-disabled': isDisabled}"
          ></feather-icon>
        </div>
        <slot />
      </a>
    </vx-tooltip>
    <vx-tooltip :text="tooltipText" v-else-if="sidebarActive" position="right">
      <router-link
        exact
        :class="[{'router-link-active': activeLink}]"
        :to="to ? to : ''"
        :target="target"
        @click.native="selectMenuItem"
      >
        <div v-if="icone" class="area-icons items-center">
          <feather-icon
            :icon="icone"
            :svgClasses="['h-8 w-8 icon-safra']"
            :class="{'menu-disabled': isDisabled}"
          ></feather-icon>
        </div>
        <vs-icon v-if="!featherIcon && !icone" :icon-pack="iconPack" :icon="icon" />
        <feather-icon v-else-if="!icone" :class="{'w-3 h-3': iconSmall}" :icon="icon" />
        <slot />
      </router-link>
    </vx-tooltip>
    <router-link
      v-else-if="to"
      exact
      :class="[{'router-link-active h-full': activeLink}]"
      :to="to"
      :target="target"
      @click.native="selectMenuItem"
    >
      <div v-if="icone">
        <feather-icon
          :icon="icone"
          :svgClasses="['h-8 w-8 icon-safra']"
          :class="{'menu-disabled': isDisabled}"
        ></feather-icon>
      </div>
      <vs-icon v-if="!featherIcon && !icone" :icon-pack="iconPack" :icon="icon" />
      <feather-icon v-else-if="!icone" :class="{'w-3 h-3': iconSmall}" :icon="icon" />
      <slot />
    </router-link>
    <a v-else :target="target" :href="href">
      <i v-if="icone">
        <img :src="icone" />
      </i>
      <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />
      <feather-icon v-else-if="!icone" :class="{'w-3 h-3': iconSmall}" :icon="icon" />
      <slot />
    </a>
  </div>
</template>

<script>
import { EventBus } from "../../../event-bus";
import AppConstants from "../../../appConstants";
import messageDialogHelper from '../../../helpers/message-dialog-helper';
export default {
  name: "v-nav-menu-item",
  props: {
    name: { type: String, default: "" },
    icone: { type: String, default: "" },
    icon: { type: String, default: "" },
    iconSmall: { type: Boolean, default: false },
    iconPack: { type: String, default: "material-icons" },
    href: { type: [String, null], default: "#" },
    to: { type: [String, Object, null], default: null },
    slug: { type: String, default: null },
    index: { type: [String, Number], default: null },
    featherIcon: { type: Boolean, default: true },
    target: { type: String, default: "_self" },
    isDisabled: { type: Boolean, default: false },
    sidebarActive: { type: Boolean },
    currentItem: { type: Object },
    isWindowDetached: { type: Boolean, default: false }
  },
  computed: {
    tooltipText() {
      if (this.sidebarActive) {
        return this.name;
      }
      return this.$t("MENU").NoRights;
    },
    canSee() {
      this.$acl.check(this.$store.state.AppActiveUser.userRole);
      return this.to
        ? this.$acl.check(this.$router.match(this.to).meta.rule)
        : true;
    },
    activeLink() {
      if (this.currentItem && this.currentCommodity) {
        return this.currentCommodity.id == this.currentItem.id;
      }
      return false;
      // return this.to == this.$route.path ||
      //   (this.$route.meta.parent == this.slug && this.to)
      //   ? true
      //   : false;
    },
    currentCommodity() {
      return this.$store.state.currentCommodity;
    },
  },
  methods: {
    selectMenuItem() {
      console.log('selectMenuItem: ', this.currentItem);
      this.$store.dispatch('updateCurrentCommodity', this.currentItem);
      if (this.isWindowDetached) {
        console.log('[router-replace] ', this.currentItem);
        // this.$router.replace({name: 'quotes', query: {currentCommodity: this.currentItem.id}});
        // this.$router.push({path: this.$route.fullPath , query: {currentCommodity: this.currentItem.id, currentContent: this.$route.query.currentContent}});
        this.$router.push({name: 'informative', params: {commodity: this.currentItem.id} , query: {currentCommodity: this.currentItem.id, currentContent: this.$route.query.currentContent}});
      }
    },
    clickLink() {
      messageDialogHelper.displayUserRightsMessage(this.name, () => {
        // this.$emit('displayContact', true);
        let text = this.$t('HELP_ATTENDANCE').NoRights_Text_Commodity;
        text = text.replace('%', this.name);
        EventBus.$emit(AppConstants.BUS_EVENT_OPENA_ATTENDANCE, text);
      });
    }
  }
};
</script>


<style lang="scss" scoped>
</style>
